// ============================================================
// draftAmounts — お客様向けの下書きに書いた合計が、予約の合計と合っているか（2026-11-03 N1）
//
// 2026-11-01 予約セッション3205（TR-KTZDT3-TLBZQY）: ホテル配車 +¥5,000 を、予約の金額は変えずにメモへ
// 「料金合計は ¥36,910 → ¥41,910 に変更」と書き、確定メールの下書き 869 に「合計 ¥41,910」と書いた。
// 予約は ¥36,910 のまま（下書きは未送信）。請求と案内が食い違う。
// AI エージェントは任意の金額に書き換えない（A14）ので、合計を変えるなら先に予約の金額を直す（apply_price_change・サイドパネル）。
// ============================================================

const TOTAL_LINE = /(合計|総額|総合計|お支払い?金額|Total|總額|總計|합계)[^\n¥￥\d]{0,30}[¥￥]?\s?([\d,]{3,})\s*(円|JPY|yen)?/gi;

/** 本文に書かれた「合計」の金額（重複なし） */
export function totalsInBody(body: string): number[] {
  const out = new Set<number>();
  for (const m of String(body ?? '').matchAll(TOTAL_LINE)) {
    const n = Number(String(m[2]).replace(/,/g, ''));
    if (Number.isFinite(n) && n >= 1000) out.add(n);
  }
  return Array.from(out);
}

/**
 * 下書きの合計が予約の合計（複数台ならグループ合計）と違うときの指摘（null なら問題なし）。
 * フリート割は請求書にだけ反映するので、「フリート割」を書いた本文は照合しない（金額は請求書で決まる）
 */
export function draftTotalProblem(body: string, expected: { sum: number; groupTotal?: number | null }): string | null {
  if (/フリート割|fleet discount/i.test(String(body ?? ''))) return null;
  const totals = totalsInBody(body);
  if (totals.length === 0) return null;
  const ok = new Set([expected.sum, expected.groupTotal].filter((n): n is number => typeof n === 'number' && n > 0));
  if (ok.size === 0) return null;
  const wrong = totals.filter((t) => !ok.has(t));
  if (wrong.length === 0) return null;
  const want = Array.from(ok).map((n) => `¥${n.toLocaleString()}`).join(' / ');
  return `下書きの合計 ${wrong.map((n) => `¥${n.toLocaleString()}`).join('・')} が予約の合計 ${want} と違う。`
    + '金額を変えるなら、先に予約の金額を直す（apply_price_change、またはスタッフがサイドパネルで）。'
    + '予約の金額のまま書くか、どう直すかをオペレータに聞くこと（AI が合計を書き換えない）';
}
